
// Helper function to calculate age from birthdate
export const calculateAge = (birthDate: string | null): number => {
  if (!birthDate) return 0;
  
  try {
    const today = new Date();
    const birth = new Date(birthDate);
    
    // Validar se a data é válida
    if (isNaN(birth.getTime())) {
      return 0;
    }
    
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    
    return age;
  } catch (error) {
    return 0;
  }
};
